import { atom } from "jotai";
import {
  zslExecutionFailedErrorMsgAtom,
  showAIStreamCreateModalAtom,
} from "@zapier/canvas-state";

import { showWelcomeModalAtom } from "./showWelcomeModalAtom";
import { promptToZslErrorAtom } from "./streamingStatusAtoms";

export const goBackToWelcomeModalCommand = atom(null, (_get, set) => {
  set(showAIStreamCreateModalAtom, false);
  set(showWelcomeModalAtom, true);
  set(zslExecutionFailedErrorMsgAtom, null); // Clear out old error alert
  set(promptToZslErrorAtom, ""); // Clear out prompt => zsl error
});
